<template>
  <div class="home text-center">
    <p id="header" class="d-flex justify-center">
      <v-img
        src="../assets/elements_graphiques-10.png"
        max-width="80"
        max-height="80"
        class="mx-8"
      >
      </v-img>
      Vue Projet
    </p>
    <v-col cols="10" class="mx-auto">
      <v-slider
        v-model="number"
        thumb-label="always"
        min="5"
        max="20"
        color="#51bdcb"
        class="pt-1"
        track-color="grey"
        append-icon="mdi-plus"
        prepend-icon="mdi-minus"
        @click:append="plusAction"
        @click:prepend="minusAction"
      ></v-slider>
    </v-col>
    <v-row class="d-flex mx-auto" cols="12">
      <v-col cols="4">
        <v-autocomplete
          :items="orderedGetAllProjects"
          v-model="projects"
          item-text="name"
          name="projects"
          label="Recherche par nom"
          color="#51bdcb"
          item-color="dark"
          chips
          multiple
          deletable-chips
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="4">
        <v-autocomplete
          :items="activities"
          v-model="activity"
          name="Activity"
          label="Recherche par pôle"
          color="#51bdcb"
          item-color="dark"
          chips
          multiple
          deletable-chips
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="4">
        <v-autocomplete
          :items="managers"
          v-model="manager"
          name="Manager"
          label="Recherche par chef de projet"
          color="#51bdcb"
          item-color="dark"
          chips
          multiple
          deletable-chips
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row class="ms-15 mb-5">
      <v-col class="mx-auto">
        <v-checkbox
          v-model="internFilter"
          label="Afficher seulement les projets internes"
          color="#51bdcb"
        >
        </v-checkbox
      ></v-col>
      <v-col class="mx-auto">
        <v-checkbox
          v-model="orderRemaining"
          label="Trier par budget consommé"
          color="#51bdcb"
        >
        </v-checkbox>
      </v-col>
      <v-col class="mx-auto">
        <v-checkbox v-model="legend" label="Montrer la légende" color="#51bdcb">
        </v-checkbox>
      </v-col>
    </v-row>
    <v-row v-if="legend">
      <v-col>
        <v-sheet
          color="#51bdcb"
          elevation="1"
          height="50"
          rounded
          width="100"
          class="mx-auto my-2"
        ></v-sheet>
        <p>Budget restant supérieur à 10%</p>
      </v-col>
      <v-col>
        <v-sheet
          color="orange"
          elevation="1"
          height="50"
          rounded
          width="100"
          class="mx-auto my-2"
        ></v-sheet>
        <p>Budget restant inférieur à 10%</p>
      </v-col>
      <v-col>
        <v-sheet
          color="red"
          elevation="1"
          height="50"
          rounded
          width="100"
          class="mx-auto my-2"
        ></v-sheet>
        <p>budget restant inférieur à 0%</p>
      </v-col>
    </v-row>
    <div
      class="pt-7"
      v-if="
        $apollo.queries.getAllProjects.loading ||
          $apollo.queries.getFollowingWeeks.loading
      "
    >
      <v-img
        src="../assets/Dual Ring-1.3s-250px.gif"
        max-height="200"
        max-width="200"
        class="mx-auto my-5"
      ></v-img>
    </div>
    <div v-else>
      <v-simple-table class="mytable">
        <template v-slot:default>
          <thead>
            <tr>
              <th></th>
              <th
                v-for="week in getFollowingWeeks"
                :key="week.id"
                class="text-center"
              >
                <v-list-item two-line class="text-center">
                  <v-list-item-content>
                    <v-list-item-title>{{ week.week }}</v-list-item-title>
                    <v-list-item-subtitle>
                      {{ week.month }} {{ week.year }} <br />
                      du {{ week.firstDate }} au {{ week.lastDate }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="project in orderedGetAllProjects" :key="project.id">
              <template
                v-if="
                  (projects.length == 0 ||
                    (projects.length != 0 &&
                      projects.includes(project.name))) &&
                    (activity.length == 0 ||
                      (activity.length != 0 &&
                        activity.includes(project.activity))) &&
                    (!currentProjectFilter ||
                      (currentProjectFilter &&
                        new Date().getTime() <
                          new Date(project.endDate).getTime())) &&
                    (!internFilter ||
                      (internFilter && project.type == 'Projet Interne')) &&
                    (manager.length == 0 ||
                      (manager.length != 0 && checkManager(project.managers)))
                "
              >
                <td id="firstCol">
                  <!-- :::: -->
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title
                        class="text-wrap font-weight-bold"
                        :title="project.name"
                      >
                        {{ project.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle
                        class="font-weight-bold"
                        v-for="manager in project.managers"
                        :key="manager.id"
                      >
                        {{ manager.name }}
                      </v-list-item-subtitle>
                      <v-list-item-content>
                        <ModalUpdateProject :project="project" />
                      </v-list-item-content>
                      <v-list-item-subtitle class="font-weight-bold">
                        Pôle : {{ project.activity }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle class="font-weight-bold">
                        du
                        {{
                          new Date(project.startDate).toLocaleDateString(
                            'fr-FR',
                            options
                          )
                        }}
                        <br />au
                        {{
                          new Date(project.endDate).toLocaleDateString(
                            'fr-FR',
                            options
                          )
                        }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        Budget : {{ numberDisplay(project.budget) }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        Consommé : {{ numberDisplay(project.consumed) }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        Planifié :
                        {{
                          numberDisplay(remainingPlanned[project.id]['planned'])
                        }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        Restant :
                        {{
                          numberDisplay(
                            remainingPlanned[project.id]['remaining']
                          )
                        }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon class="my-auto px-5">
                      <!-- icon assignment -->
                      <ModalAssignment :project="project" />
                    </v-list-item-icon>
                    <v-list-item-icon class="my-auto px-5">
                      <!-- icon assignment -->
                      <ModalUpdateAss
                        :project="project"
                        :assignments="project.assignments"
                        :isFromProjectVue="true"
                      />
                    </v-list-item-icon>
                  </v-list-item>
                </td>
                <td
                  align="center"
                  v-for="(detailledProject, key) in detailledProjects[
                    project.id
                  ]"
                  :key="key + project.id"
                >
                  <div
                    class="text-center d-flex align-center justify-space-around"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card
                          class="text-center assignment"
                          v-bind="attrs"
                          v-on="on"
                          :color="detailledProject.color"
                          width="90%"
                        >
                          <v-list-item
                            v-if="detailledProject.days > 0"
                            two-line
                            class="text-center"
                          >
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ numberDisplay(detailledProject.days) }}J
                              </v-list-item-title>
                              <v-list-item-subtitle>
                                {{ detailledProject.resources }}R
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>
                      </template>
                      <div
                        v-if="
                          detailledProject['names'].length > 0 &&
                            detailledProject.assignments.length > 0
                        "
                      >
                        <p
                          v-for="(detailled,
                          index) in detailledProject.assignments"
                          :key="index"
                        >
                          {{ detailledProject['names'][index] }} :
                          {{ numberDisplay(detailled.daysWorked) }}J <br />
                        </p>
                      </div>
                    </v-tooltip>
                  </div>
                </td>
              </template>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <!-- Bouton création projet -->
    <ModalCreateProject class="py-9" />
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable prefer-template */
import ModalCreateProject from '../components/ModalCreateProject.vue';
import ModalAssignment from '../components/ModalAssignment.vue';
import ModalUpdateProject from '../components/ModalUpdateProject.vue';
import ModalUpdateAss from '../components/ModalUpdateAss.vue';
import {
  GET_ALL_PROJECTS,
  GET_FOLLOWING_WEEKS,
} from '../graphql/GraphQLQueries';

const _ = require('lodash');

export default {
  apollo: {
    getAllProjects: {
      query: GET_ALL_PROJECTS,
      error(error) {
        if (error.graphQLErrors.length > 0) {
          if (error.graphQLErrors[0].message === 'Unauthenticated!') {
            if (localStorage) {
              localStorage.removeItem('apollo-token');
            }
            this.$router.push('/');
          }
        }
        console.error(error); // eslint-disable-line no-console
      },
    },
    getFollowingWeeks: {
      query: GET_FOLLOWING_WEEKS,
      variables() {
        return {
          number: this.number,
        };
      },
    },
  },

  components: {
    ModalCreateProject,
    ModalAssignment,
    ModalUpdateProject,
    ModalUpdateAss,
  },

  data() {
    return {
      options: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      },
      icon: 'mdi-calendar-multiple',
      getAllProjects: [],
      getFollowingWeeks: [],
      projects: '',
      number: 5,
      activity: '',
      orderRemaining: false,
      activities: ['BI', 'ERP', 'Web'],
      legend: false,
      currentProjectFilter: false,
      internFilter: false,
      manager: '',
    };
  },

  methods: {
    plusAction() {
      this.number = this.number + 1 || 5;
    },
    minusAction() {
      this.number = this.number - 1 || 20;
    },
    numberDisplay(nbr) {
      if (nbr === parseInt(nbr, 10)) {
        return nbr;
      }
      return Number.parseFloat(nbr).toFixed(1);
    },
    checkManager(managerObject) {
      for (let i = 0; i < managerObject.length; i += 1) {
        const nameOfManager = managerObject[i].name;
        if (this.manager.includes(nameOfManager)) {
          return true;
        }
      }
      return false;
    },
  },

  computed: {
    orderedGetAllProjects() {
      if (!this.orderRemaining) {
        return _.orderBy(this.getAllProjects, 'name');
      }
      return _.orderBy(this.getAllProjects, 'consumed');
    },
    managers() {
      const managers = [];
      this.getAllProjects.forEach((project) => {
        project.managers.forEach((manager) => {
          if (!managers.includes(manager.name)) {
            managers.push(manager.name);
          }
        });
      });
      return managers;
    },
    detailledProjects() {
      let key;
      let color;
      const detailled = {};
      if (this.getAllProjects) {
        // Parcours all project from the query result
        this.getAllProjects.forEach((project) => {
          let cumulDaysWorked = project.consumed;
          detailled[project.id] = {};
          if (this.getFollowingWeeks) {
            this.getFollowingWeeks.forEach((week) => {
              detailled[project.id][week.id] = {
                days: 0,
                resources: 0,
                assignments: [],
                names: [],
              };
            });
            if (project.assignments && project.assignments.length > 0) {
              project.assignments.forEach((assignment) => {
                assignment.assignmentDetail.forEach((detail) => {
                  key = `${detail.year}${detail.week.toLocaleString('en-US', {
                    minimumIntegerDigits: 2,
                    useGrouping: false,
                  })}`;
                  const weekElements = _.filter(this.getFollowingWeeks, {
                    year: detail.year,
                    week: detail.week,
                  });

                  // check if we have pass week or not
                  if (weekElements.length > 0) {
                    detailled[project.id][key].days += detail.daysWorked;
                    detailled[project.id][key].assignments.push(detail);
                    detailled[project.id][key].names.push(
                      assignment.resource.name
                    );
                  }
                  // Card color pb
                  // else {
                  //   cumulDaysWorked += detail.daysWorked;
                  // }
                });
              });

              const keys = Object.keys(detailled[project.id]);
              const values = Object.values(detailled[project.id]);
              for (let i = 0; i < keys.length; i += 1) {
                const element = values[i];

                element.resources = element.names.length;

                // calcul percentage advancement
                const percentage = (cumulDaysWorked * 100) / project.budget;
                cumulDaysWorked += element.days;

                // Check advancement to return the color
                if (percentage >= 80 && percentage <= 100) {
                  color = 'orange';
                } else if (percentage > 100) {
                  color = 'red';
                } else {
                  color = '#51bdcb';
                }
                element.color = color;
              }
            }
          }
        });
      }
      return detailled;
    },
    remainingPlanned() {
      const remainingPlanned = {};
      if (this.getAllProjects) {
        this.getAllProjects.forEach((project) => {
          let planned = 0;
          let remaining = project.budget - project.consumed;
          if (project.assignments) {
            project.assignments.forEach((assignment) => {
              assignment.assignmentDetail.forEach((detail) => {
                planned += detail.daysWorked;
              });
            });
          }
          remaining -= planned;
          remainingPlanned[project.id] = {
            planned,
            remaining,
          };
        });
      }
      return remainingPlanned;
    },
  },
};
</script>

<style scoped>
p#header {
  font-size: 55px;
  margin-top: 50px;
  color: gray;
}
.theme--light.v-data-table tbody tr:not(:last-child) {
  border-bottom: none !important;
}
#firstCol {
  width: 25% !important;
}
.v-progress-circular {
  margin: 1rem;
}
</style>
